import { useFieldProps } from "Components/Hooks";
import { Horizontal } from "Components/Horizontal";
import { Modal } from "Components/Modal";
import { FormikValues } from "formik";
import { Checkbox } from "Inputs/Checkbox";
import { Dropdown } from "Inputs/Dropdown";
import { FileInput } from "Inputs/FileInput";
import { Textbox } from "Inputs/Textbox";
import React, { useState } from "react";

export function AccreditationInput(props: {
  options: string[];
  otherOption: string;
  values: FormikValues;
  validFileTypes: string;
  certificateFilename?: string;
  isSup: boolean;
  hasOpenWaterCoverage: boolean;
}) {
  const field = useFieldProps("FitnessInstructorAccreditationOrganization");
  const disabledOptions = [undefined, "----------------", ""];
  const hasCertificate = field.value !== "No Certificate";
  const optionElements = props.options.map(e => (
    <option key={e} value={e} disabled={disabledOptions.includes(e)}>
      {e}
    </option>
  ));
  const showOpenWaterRequirementModal =
    props.hasOpenWaterCoverage && !hasCertificate;
  return (
    <>
      <Horizontal
        isRequired
        label={`${props.isSup ? "SUP" : ""} Accreditation Organization`}
      >
        <Dropdown
          fieldName={field.name}
          options={<>{optionElements}</>}
          placeholder={`${
            props.isSup ? "SUP" : "PT"
          } Accreditation Organization...`}
        />
      </Horizontal>
      {field.value === props.otherOption && <OtherOrganizationInput />}
      {field.value && hasCertificate && <CertificateInput {...props} />}
      <OpenWaterRequirementModal
        key={showOpenWaterRequirementModal ? 1 : 0}
        isModalVisible={showOpenWaterRequirementModal}
      />
    </>
  );
}

function OtherOrganizationInput() {
  return (
    <>
      <Horizontal isRequired label="Other Organization">
        <Textbox
          fieldName="OtherAccreditationOrganization"
          placeholder="Personal training certification organization"
        />
      </Horizontal>
      <Horizontal
        isRequired
        label="Minimum Training Confirmation"
        shouldNotPadLabel
      >
        <Checkbox fieldName="HasMinimumHoursForOtherAccOrg">
          I confirm that the Accreditation Certificate I am uploading required
          at least 200 hours of training.
        </Checkbox>
      </Horizontal>
    </>
  );
}

function CertificateInput(props: {
  validFileTypes: string;
  certificateFilename?: string | undefined;
}) {
  return (
    <>
      <Horizontal>
        <div>
          <div className="is-italic">
            <div>
              Accepted file upload types: GIF, JPG, JPEG, TIFF, PDF. The maximum
              size for uploaded files is 15 MB.
            </div>
            <div>
              Please note that if you do not have a virtual copy of your
              certificate,{" "}
              <span className="has-text-weight-bold">
                you may also upload a picture of your certificate taken with
                your camera or smart phone.
              </span>
            </div>
          </div>
          <FileInput
            fieldName="CertificateFile"
            validFileTypes={props.validFileTypes}
            filename={props.certificateFilename}
            maxSizeBytes={15728640}
          />
        </div>
      </Horizontal>
      <Horizontal isRequired label="Years of Accredited Experience">
        <Textbox
          fieldName="YearsAccreditedExperience"
          placeholder="Years of Accredited Experience (round up)"
        />
      </Horizontal>
    </>
  );
}

export function OpenWaterRequirementModal(props: { isModalVisible: boolean }) {
  const [isModalVisible, setIsModalVisible] = useState(props.isModalVisible);
  return (
    <Modal
      isModalVisible={isModalVisible}
      onSubmit={() => setIsModalVisible(false)}
      onClickOutside={() => setIsModalVisible(false)}
      modalTitle="Open Water Requirement"
    >
      To purchase Open Water coverage, you must be an Accredited Instructor.
      Please upload an Accreditation Certificate or go back and remove the Open
      Water coverage.
    </Modal>
  );
}
